import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grod4",
  "use": "icon-grod4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-grod4\"><path d=\"M106.666667 106.666667h362.666666v362.666666H106.666667V106.666667zM106.666667 554.666667v362.666666h362.666666V554.666667H106.666667zM554.666667 554.666667v362.666666h362.666666V554.666667H554.666667zM917.333333 469.333333V106.666667H554.666667v362.666666h362.666666z\" p-id=\"2625\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol